import React from 'react'
import { Link } from 'react-router-dom'

const onExternalLinkClick = (href, e) => {
	e.stopPropagation()
	e.preventDefault()

	window.open(href, '_blank')

	return false
}

const renderBlock = (props, editor, next) => {
	const { attributes, children, node, isSelected } = props

	const attrs = attributes
	attrs.className = ''

	if (isSelected && props.isFocused && props.parent.object === 'document') {
		attrs.className = attrs.className
			? ` ${attrs.className} has-focus`
			: ' has-focus'
	}

	switch (node.type) {
		case 'link': {
			const { data } = node
			const href = data.get('href') || '#'
			const sameOrigin = !!href.startsWith(window.location.origin)

			return sameOrigin ? (
				<Link to={href.replace(window.location.origin, '')}>
					{children}
				</Link>
			) : (
				<a
					{...attrs}
					href={href}
					rel="noopener noreferrer nofollow"
					onClick={e => onExternalLinkClick(href, e)}
					target="_blank"
				>
					{children}
				</a>
			)
		}
		default:
			return next()
	}
}

export default renderBlock
